import { Button } from "@faire/slate/components/button";
import { ClipboardText } from "@phosphor-icons/react";

import { ReportedProductCard } from "./ReportedProductCard";
import { RetailerMobileNav } from "./RetailerMobileNav";
import {
  BRAND_NAME,
  RETURN_BY_DATE,
  RETURN_BY_DATE_LONG,
  RETURN_ITEMS,
} from "./retailerReportIssueData";

export const ReportReceivedScreen = () => (
  <div className="bg-fs-surface-primary flex min-h-full flex-col">
    <RetailerMobileNav showProgress={false} />
    <div className="flex flex-1 flex-col px-(--slate-spacing-section-medium) pt-(--slate-spacing-section-medium) pb-(--slate-spacing-section-large)">
      <div className="flex flex-col gap-(--slate-spacing-element-medium) pb-(--slate-dimensions-4)">
        <div className="flex flex-col gap-(--slate-dimensions-2)">
          <ClipboardText
            size={40}
            weight="regular"
            className="text-fs-text-primary"
            aria-hidden
          />
          <h1 className="type-fs-page-heading text-fs-text-primary">
            Report received.
            <br />
            Return affected items by {RETURN_BY_DATE}.
          </h1>
        </div>
        <p className="type-fs-paragraph text-fs-text-primary">
          If {BRAND_NAME} approves the replacements, a new order will be charged
          separately — shipping is free.
        </p>
      </div>

      <div className="flex flex-col">
        <hr className="border-fs-border-muted w-full border-0 border-t" />
        <div className="flex flex-col gap-(--slate-spacing-element-medium) pt-(--slate-dimensions-4)">
          <h2 className="type-fs-page-heading text-fs-text-primary">
            Return instructions
          </h2>
          <ol className="type-fs-paragraph text-fs-text-primary flex list-decimal flex-col gap-(--slate-dimensions-2) ps-[21px]">
            <li>Package up the affected items.</li>
            <li>
              Print and attach the pre-paid return label to the top of the
              package.
            </li>
            <li>
              Drop off to a FedEx drop-off location by {RETURN_BY_DATE_LONG}.
            </li>
          </ol>
          <span className="type-fs-paragraph-medium text-fs-text-primary">
            4 items to return:
          </span>
          <div className="flex flex-col gap-(--slate-spacing-element-medium)">
            {RETURN_ITEMS.map((product) => (
              <ReportedProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </div>
    </div>
    <div className="bg-fs-surface-primary sticky bottom-0 p-(--slate-spacing-section-medium)">
      <Button variant="secondary" fullWidth>
        View return label
      </Button>
    </div>
  </div>
);
